import { BrowserRouter, Routes, Route } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import NoticeBoard from "@/pages/NoticeBoard";
import TopAgencies from "@/pages/TopAgencies";
import Resellers from "@/pages/Resellers";
import Recharge from "@/pages/Recharge";
import OfficialHost from "@/pages/OfficialHost";
import HostSalaryLookup from "@/pages/HostSalaryLookup";
import PkBattles from "@/pages/PkBattles";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import ManageResellers from "@/pages/admin/ManageResellers";
import ManageNotices from "@/pages/admin/ManageNotices";
import ManageRankings from "@/pages/admin/ManageRankings";
import ManageBanners from "@/pages/admin/ManageBanners";
import ManageHostApplications from "@/pages/admin/ManageHostApplications";
import ManageSalaries from "@/pages/admin/ManageSalaries";
import ManagePkBattles from "@/pages/admin/ManagePkBattles";
import ManageSettings from "@/pages/admin/ManageSettings";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/notices" element={<NoticeBoard />} />
          <Route path="/top-agencies" element={<TopAgencies />} />
          <Route path="/resellers" element={<Resellers />} />
          <Route path="/recharge" element={<Recharge />} />
          <Route path="/official-host" element={<OfficialHost />} />
          <Route path="/official-host-policy" element={<OfficialHost />} />
          <Route path="/host-salary" element={<HostSalaryLookup />} />
          <Route path="/pk-battles" element={<PkBattles />} />
        </Route>

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="resellers" element={<ManageResellers />} />
          <Route path="rankings" element={<ManageRankings />} />
          <Route path="notices" element={<ManageNotices />} />
          <Route path="banners" element={<ManageBanners />} />
          <Route path="host-applications" element={<ManageHostApplications />} />
          <Route path="salaries" element={<ManageSalaries />} />
          <Route path="pk-battles" element={<ManagePkBattles />} />
          <Route path="settings" element={<ManageSettings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
